<template>
  <div id="app">
    <Header/>
    <router-view :key="$route.fullPath"/>
    <Footer/>
  </div>
</template>
<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  export default {
    components: { Header, Footer },
    metaInfo: {
      title: 'SSAL国际课程（原广东实验中学A LEVEL国际课程）',
      // title: '广东双实国际教育咨询有限公司',
      meta: [
        {
          name: 'keywords',
          content: '省实A LEVEL,广东实验中学A LEVEL,广东实验中学国际部,省实国际部,省实国际班,省实国际课程,广州国际学校,广东国际学校'
        },
        {
          name: 'description',
          content: '广东实验中学A Level国际课程|广东实验中学国际部|省实国际|国际学校'
        }
      ]
    }
  }

</script>
<style lang="scss">
  body {
    height: 100%;
    width: 100%;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    font-family: "Microsoft YaHei",微软雅黑, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
    overflow: auto;
    margin: 0;
    padding: 0;
  }
  #app {
    font-family: "Microsoft YaHei",微软雅黑, Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-width: 1200px;
  }
  @function px2rem($px) {
    $rem: 18px;
    @return($px/$rem)+rem
  }
</style>



// WEBPACK FOOTER //
// src/App.vue